// Clases Tailwind reutilizables (estilo "Moderno denso" - Square/Shopify)
export const ui = {
  page: "flex-1 overflow-y-auto p-6 bg-slate-100",
  header:
    "bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between",
  title: "text-2xl font-bold text-slate-900",
  subtitle: "text-sm text-slate-500",
  card: "bg-white rounded-xl border border-slate-200 overflow-hidden",
  cardPad: "bg-white rounded-xl border border-slate-200 p-5",
  table: "w-full text-sm",
  thead:
    "bg-slate-50 text-slate-700 text-xs font-semibold uppercase tracking-wide",
  th: "px-4 py-3 text-left",
  td: "px-4 py-3 text-slate-700",
  tr: "border-b border-slate-100 hover:bg-slate-50 cursor-pointer",
  input:
    "w-full border border-slate-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500",
  label:
    "block text-xs font-semibold text-slate-700 uppercase tracking-wide mb-1",
  btnPrimary:
    "bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-2.5 px-5 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
  btnSecondary:
    "bg-white border border-slate-200 hover:border-slate-400 text-slate-700 font-medium py-2.5 px-5 rounded-xl transition-colors",
  btnDanger:
    "bg-rose-500 hover:bg-rose-600 text-white font-bold py-2.5 px-5 rounded-xl transition-colors",
  modalOverlay:
    "fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4",
  modalCard:
    "bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl max-h-[90vh] overflow-y-auto",
  modalCardLg:
    "bg-white rounded-2xl p-6 max-w-2xl w-full shadow-2xl max-h-[90vh] overflow-y-auto",
  empty: "text-slate-400 text-center py-12",
  error:
    "bg-rose-50 border border-rose-200 text-rose-700 rounded-lg p-4 text-sm",
  skeleton: "bg-slate-200 animate-pulse rounded",
  badge: "inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold",
};
